function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Usa = function Usa(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 3264 1943.4",
    a11yTitle: "Usa"
  }, props), React.createElement("path", {
    d: "m0 0h3264v1943.39h-3264z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "m0 0h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 299.94h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 605.88h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 900.02h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 1193.96h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 1499.9h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 1793.84h3264v149.56h-3264z",
    fill: "#a52d36"
  }), React.createElement("path", {
    d: "m0 0h1472.4v1049.38h-1472.4z",
    fill: "#3a3a6b"
  }), React.createElement("g", {
    fill: "#fff"
  }, React.createElement("path", {
    d: "m182 87h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m426.35 87h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m676.71 87h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m922.74 87h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1168.76 87h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1417.79 87h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m182 296.72h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m426.35 296.72h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m676.71 296.72h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m922.74 296.72h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1168.76 296.72h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1417.79 296.72h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m304.84 191.56h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m549.2 191.56h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m799.56 191.56h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1045.58 191.56h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1291.61 191.56h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m182 508.21h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m426.35 508.21h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m676.71 508.21h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m922.74 508.21h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1168.76 508.21h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1417.79 508.21h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m304.84 403.05h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m549.2 403.05h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m799.56 403.05h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1045.58 403.05h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1291.61 403.05h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m182 715.2h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m426.35 715.2h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m676.71 715.2h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m922.74 715.2h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1168.76 715.2h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1417.79 715.2h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m304.84 610.04h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m549.2 610.04h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m799.56 610.04h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1045.58 610.04h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1291.61 610.04h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m182 926.69h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m426.35 926.69h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m676.71 926.69h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m922.74 926.69h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1168.76 926.69h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1417.79 926.69h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m304.84 821.53h-43.66l-14-40-.17.48-.17-.48-14 40h-43.66l36 32-16 46 37.83-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m549.2 821.53h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m799.56 821.53h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  }), React.createElement("path", {
    d: "m1045.58 821.53h-43.67l-14-40-.16.48-.17-.48-14 40h-43.67l36 32-16 46 37.84-27 37.83 27-16-46z"
  }), React.createElement("path", {
    d: "m1291.61 821.53h-43.67l-14-40-.17.48-.16-.48-14 40h-43.67l36 32-16 46 37.83-27 37.84 27-16-46z"
  })));
};